import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';

import Statistics from './Statistics';
import NoBannerStatistics from './NoBannerStatistics';
import TopStatistics from './TopStatistics';
import MediaCtrStatistics from './MediaCtrStatistics';
import MediaFlucAmtStatistics from './MediaFlucAmtStatistics';
import MediaFluctuationStatistics from './MediaFluctuationStatistics';
import TargetStatistics from './TargetStatistics';
import MediaRoasStatistics from './MediaRoasStatistics';
import FluctuationScriptStatistics from './FluctuationScriptStatistics';
import FrameSize from './FrameSize';

const MediaStatistics = () => {
  let { path } = useRouteMatch();
  const { menu, common } = useSelector(({ menu, common }) => ({
    menu: menu.list === null ? new Map() : menu.list,
    common: common,
  }));
  const [loading, setLoading] = useState(false);

  const tps = [
    'KL',
    'LC',
    'TC',
    'TV',
    'TR',
    'RE',
    'WC',
    'MC',
    'TP',
    'WP',
    'SP',
    'HP',
    'HR',
    'CH',
    'CR',
    'HV',
    'HE',
    'CW',
    'OS',
    'RC',
    'WV',
    'WR',
    'MV',
    'FR',
    'SR',
    'PR',
    'ST',
    'HU',
    'BP',
    'RM',
    'MT',
    'RU',
    'PU',
    'MU',
    'HM',
    'MO',
    'US',
    'UM',
    'GG',
    'GS',
    'MM',
    'IB',
    'KM',
    'IK',
    'MK',
    'CM',
    'MR',
    'AU',
    'SW',
    'PA',
    'AD',
    'EX',
    'PB',
    'CC',
    'SA',
    'SJ',
    'AT',
    'TM',
  ];

  const tabList = () => {
    if (common.productCodeList.size > 0) {
      for (let curMenu of menu.values()) {
        if (typeof curMenu.subMenu !== 'undefined') {
          const cur = curMenu.subMenu.get(path);
          if (typeof cur !== 'undefined') {
            // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
            return cur.subMenu;
          }
        }
      }
    }
  };

  const handleLoading = (value) => {
    setLoading(value);
  };

  return (
    <MainTemplate loading={loading}>
      <MbTabs
        name="MediaStatistics"
        tabMenuList={tabList()}
        tabs={{
          // 매체별 통계
          '/report/media': { tabComponent: <Statistics /> },
          // 지면별 타겟팅분포
          '/report/media/mediatarget': {
            tabComponent: (
              <TargetStatistics
                handleLoading={handleLoading}
                tps={tps}
                targeting={common.productCodeList}
              />
            ),
          },
          // 프레임RTB통계
          '/report/media/frameSize': {
            tabComponent: <FrameSize />,
          },
          //매체등락보고
          '/report/media/fluctuation': {
            tabComponent: <MediaFluctuationStatistics />,
          },
          //매체지면등락보고
          '/report/media/fluctuationScript': {
            tabComponent: <FluctuationScriptStatistics />,
          },
          //지면등락보고
          '/report/media/scriptFluctuation': {
            tabComponent: <MediaFlucAmtStatistics />,
          },
          //지면등락보고CTR
          '/report/media/scriptFluctuationCtr': {
            tabComponent: <MediaCtrStatistics />,
          },
          // 지면 Roas 통계
          '/report/media/media_roas': { tabComponent: <MediaRoasStatistics /> },
          '/report/media/media_top': { tabComponent: <TopStatistics /> },
          '/report/media/nobanner': { tabComponent: <NoBannerStatistics /> },
        }}
      />
    </MainTemplate>
  );
};

export default MediaStatistics;
